"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSetDifference = exports.getSetIntersection = exports.getSetUnion = exports.getSetsContainCommonEntry = void 0;
const getSetsContainCommonEntry = (a, b) => exports.getSetIntersection(a, b).size > 0;
exports.getSetsContainCommonEntry = getSetsContainCommonEntry;
const getSetUnion = (a, b) => new Set([...a, ...b]);
exports.getSetUnion = getSetUnion;
const getSetIntersection = (a, b) => new Set([...a].filter((item) => b.has(item)));
exports.getSetIntersection = getSetIntersection;
// Gets items in a not in b
const getSetDifference = (a, b) => new Set([...a].filter((item) => !b.has(item)));
exports.getSetDifference = getSetDifference;
//# sourceMappingURL=set_utils.js.map